import * as React from 'react';
import styled from 'styled-components';
import Container from 'containers/Container';

const Wrapper = styled.header`
  height: max-content;
  padding-bottom: 24px;
  margin-bottom: 24px;
  box-sizing: border-box;
  border-bottom: 1px solid ${({theme}) => `
    ${theme.variables.borderColor};
  `};
`;

/**
 * This component renders the header.
 * @param {React.PropsWithChildren<any>} props
 * @return {React.ReactElement<React.PropsWithChildren<any>>}
 * @constructor
 */
export default function Header(
    props: React.PropsWithChildren<any>,
): React.ReactElement<React.PropsWithChildren<any>> {
  return (
    <Wrapper>
      <Container>
        {props.children}
      </Container>
    </Wrapper>
  );
}
